app.controller("AddGradeComponentController", [
    "$scope", "GradeTemplate", "$uibModalInstance", "params", "Season",
    function ($scope, GradeTemplate, $uibModalInstance, params, Season) {
        $scope.relative = 1;
        $scope.absolute = 1;
        $scope.type = "grade";
        $scope.replace = "";
        $scope.right = "";
        $scope.index = 1;
        $scope.minValue = 0;
        $scope.closesSelection = false;
        $scope.mustComplete = false;
        $scope.startWeekNumber = null;
        $scope.durationWeeks = null;

        var componentParentId = null;
        if (params.parent) {
            componentParentId = params.parent._id;
        }

        var types = [
            {name: "ქულა", value: "grade"},
            {name: "ჯგუფი", value: "group"}
        ];

        $scope.items = params.items;

        $scope.types = [types[0]];
        if (params.parent === null) {
            $scope.types.push(types[1]);
        }

        function generateWeekOptions() {
          Season.getCurrent()
            .then(function (season) {
              if (!season) {
                $scope.startWeekOptions = [];
                $scope.durationOptions = [];
                return;
              }

              $scope.startWeekOptions = season.weeks.map(function (week) {
                return Number(week.weekNumber);
              });

              $scope.durationOptions = season.weeks.map(function (week) {
                return Number(week.weekNumber);
              });
            });
        }

        generateWeekOptions();

        $scope.onStartWeekChange = function () {
          if (!$scope.startWeekNumber) {
            $scope.durationOptions = $scope.startWeekOptions.concat([]);
            return;
          }

          var maxDuration = $scope.startWeekOptions.length - $scope.startWeekNumber + 1; //at least 1 week duration

          $scope.durationOptions = [];

          for (var i = 1; i <= maxDuration; i++) {
            $scope.durationOptions.push(i);
          }
        };

        $scope.create = function () {
            var replace = $scope.replace === "" ? null : $scope.replace;
            GradeTemplate.addComponent({
                gradeTemplate: params.gradeTemplate,
                parent: componentParentId,
                replace: replace,
                name: $scope.name,
                type: $scope.type,
                relative: $scope.relative,
                absolute: $scope.absolute,
                minValue: $scope.minValue,
                closesSelection: $scope.closesSelection,
                mustComplete: $scope.mustComplete,
                right: $scope.right,
                index: $scope.index,
                startWeekNumber: $scope.startWeekNumber,
                durationWeeks: $scope.durationWeeks
            }).then(function () {
                $uibModalInstance.close();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

    }
]);
